export enum BookmarksRoutePath {
    Verses = '/bookmarks/verses',
    Hadiths = '/bookmarks/hadiths',
    Duas = '/bookmarks/duas'
}
